import { useEffect } from 'react';

const useClickLabelInputSwitch = (name, cb = () => {}, deps = []) => {
  const labelEle = document.getElementsByClassName(name)?.[0];
  useEffect(() => {
    const listener = () => {
      cb();
    };
    labelEle?.addEventListener('mousedown', listener);
    labelEle?.addEventListener('touchstart', listener);
    return () => {
      labelEle?.removeEventListener('mousedown', listener);
      labelEle?.removeEventListener('touchstart', listener);
    };
  }, [labelEle, ...deps]);
};

export default useClickLabelInputSwitch;
